import { CommonPipesModule } from 'app/shared/pipes/common-pipes.module';
import { CancelWorkflowDialogComponent } from './taskstructure/cancel-workflow-dialog/cancel-workflow-dialog.component';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DomSanitizer } from '@angular/platform-browser'

import { EditorModule, CalendarModule } from 'primeng/primeng';
import { DatepickerModule } from 'angular2-material-datepicker'

import { AppRoutingModule } from 'app/app-routing.module';

import { AddTaskComponent } from './addtask/add-task.component';
import { DelegateTaskComponent } from './delegatetask/delegate-task.component';
import { TaskGuideComponent } from './taskguide/task-guide.component';
import { TaskStructureComponent } from './taskstructure/task-structure.component';
import { TaskPanelComponent } from './taskpanel/task-panel.component';
import { TaskDetailsComponent } from './taskdetails/task-details.component';
import { TaskPopoutComponent } from 'app/task/taskpopout/task-popout.component';
import { TaskWidgetComponent } from './taskwidget/task-widget.component';
import { TaskService } from './task.service';

@NgModule({
    declarations: [
        AddTaskComponent,
        DelegateTaskComponent,
        TaskStructureComponent,
        CancelWorkflowDialogComponent,
        TaskPanelComponent,
        TaskDetailsComponent,
        TaskGuideComponent,
        TaskPopoutComponent,
        TaskWidgetComponent,
    ],
    imports: [
        MaterialModule.forRoot(),
        BrowserModule,
        FlexLayoutModule,
        EditorModule,
        ReactiveFormsModule,
        FormsModule,
        DatepickerModule,
        CalendarModule,
        AppRoutingModule,
        CommonPipesModule
    ],
    providers: [
        TaskService,
    ],
    entryComponents: [
        AddTaskComponent,
        DelegateTaskComponent,
        TaskStructureComponent,
        TaskGuideComponent,
        CancelWorkflowDialogComponent
    ],
    exports: [
        TaskPanelComponent,
        TaskDetailsComponent,
        TaskGuideComponent,
        TaskPopoutComponent,
        TaskWidgetComponent
    ]
})

export class TaskModule { }



// WEBPACK FOOTER //
// ./src/app/task/task.module.ts